import { gql } from '@apollo/client';

export const UPDATE_BOARDER_WEEKEND_STAYS = gql`
  mutation UpdateBoarderWeekendStays($input: UpdateBoarderWeekendStaysInput!) {
    updateBoarderWeekendStays(input: $input) {
      boarderId
    }
  }
`;
